import strings from '../../data/strings'

export const getLabel = (stream, isLive, isMinimized) => {
  const currentLanguage = 'en'
  const prefix = isLive ? strings[currentLanguage].nowPlaying : strings[currentLanguage].startingSoon
  if (isMinimized) return `${prefix}: ${stream.title}`
  return prefix
}